export const commonTranslation = {
  fi: {
    Common: {
      success: 'Onnistui',
      FeedbackSuccess: 'Palautteesi on lähetetty onnistuneesti',
    },
  },
};
